interface AvailabilityColumn {
  accessorKey?: string;
  id?: string;
  size?: number;
}

interface AvailabilityCounterparty {
  name?: string;
  quantity?: number;
}

interface AvailabilityRow {
  counterparties?: AvailabilityCounterparty[];
  quantity?: number;
}

export const calculateAvailabilityColumnWidths = (
  columns: AvailabilityColumn[],
  data: readonly AvailabilityRow[]
): Record<string, number> => {
  const widths: Record<string, number> = {};
  // Scan all rows so widths stay stable regardless of sort order.
  const sampleData = data;

  columns.forEach((column) => {
    const columnId = column.accessorKey || column.id;
    if (!columnId) return;
    if (column.size) {
      widths[columnId] = column.size;
      return;
    }
    if (columnId === 'rowNumber') {
      widths[columnId] = 32;
      return;
    }
    if (columnId === 'counterparties') {
      // Dynamic width for counterparties based on content
      let maxWidth = 300;
      sampleData.forEach((row) => {
        const cps = row.counterparties || [];
        let contentWidth = 0;
        cps.forEach((cp: AvailabilityCounterparty, idx: number) => {
          const nameWidth = (cp.name || '').length * 7;
          const quantityWidth = (cp.quantity?.toLocaleString('en-US') || '0').length * 7;
          const rowQty = row.quantity ?? 0;
          const cpQty = cp.quantity ?? 0;
          const percentage = rowQty > 0 ? ((cpQty / rowQty) * 100).toFixed(1) : '0.0';
          const percentageWidth = percentage.length * 7;
          contentWidth += nameWidth + 10 + quantityWidth + percentageWidth + 40 + 16 + 16;
          if (idx < cps.length - 1) contentWidth += 16;
        });
        maxWidth = Math.max(maxWidth, contentWidth + 30);
      });
      widths[columnId] = Math.min(maxWidth, 1200);
      return;
    }
    let maxContentWidth = 80;
    sampleData.forEach((row) => {
      const value = (row as unknown as Record<string, unknown>)[columnId];
      const stringValue = String(value || '');
      let charWidth = 7;
      if (['symbol_id'].includes(columnId)) {
        charWidth = 8;
      }
      const contentWidth = stringValue.length * charWidth + 24;
      maxContentWidth = Math.max(maxContentWidth, contentWidth);
    });
    widths[columnId] = Math.min(maxContentWidth, 300);
  });
  return widths;
};
